import querystring from "query-string";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { PageSaveHistoryAndParams } from "../../../redux/page/actions/default";

export const usePageBootstrap = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    useEffect(() => {
        dispatch(
            new PageSaveHistoryAndParams({
                history: history,
                query: querystring.parse(location.search) as Record<
                    string,
                    string
                >,
            }).create()
        );
    }, []);
};
